import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, PromotionCode } from '../types/items';
import { transformList } from './transformer';

class VideoService {
  private route = apis.promotionCode;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<PromotionCode>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<PromotionCode>(`${this.route.list}/${id}`);

  template = () => this.api.get<PromotionCode>(`${this.route.list}/new`);

  save = (id: ItemId, promotionCode: PromotionCode) => this.api.put(`${this.route.list}/${id}`, promotionCode);

  create = ({
    id, ref, permissions, ...video
  }: PromotionCode) => this.api.post<PromotionCode>(this.route.list, video);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

  verify = (code: string) => this.api.get<PromotionCode>(`${this.route.verify}`, { promotion_code: code });
}

export default new VideoService(apiService);
